import useReveal from "../../hooks/useReveal";
import { IMAGES } from "../../lib/data";

export const Gallery = () => {
  const headRef = useReveal();

  // Asymmetrical masonry layout (CSS grid)
  const tiles = [
    { src: IMAGES.gallery[0], cls: "md:col-span-5 md:row-span-2 aspect-[3/4] md:aspect-auto", alt: "Plage" },
    { src: IMAGES.gallery[1], cls: "md:col-span-7 aspect-[4/3]", alt: "Vue mer" },
    { src: IMAGES.gallery[2], cls: "md:col-span-4 aspect-[1/1]", alt: "Terrasse" },
    { src: IMAGES.gallery[3], cls: "md:col-span-3 aspect-[1/1]", alt: "Transats" },
    { src: IMAGES.gallery[4], cls: "md:col-span-6 md:row-span-2 aspect-[4/3] md:aspect-auto", alt: "Cocktail" },
    { src: IMAGES.gallery[5], cls: "md:col-span-6 aspect-[4/3]", alt: "Cuisine" },
  ];

  return (
    <section
      id="galerie"
      data-testid="gallery-section"
      className="bg-zp-cream py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div
          ref={headRef}
          className="reveal grid lg:grid-cols-12 gap-8 items-end mb-16"
        >
          <div className="lg:col-span-7">
            <p className="overline text-zp-navy/60 mb-6 flex items-center gap-3">
              <span className="dot" /> Galerie
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-zp-navy">
              Des instantanés
              <br />
              <span className="italic font-light">de nos journées.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex lg:justify-end">
            <a
              href="https://www.instagram.com/zenithplage/"
              target="_blank"
              rel="noreferrer"
              data-testid="gallery-instagram-link"
              className="link-underline text-sm uppercase tracking-widest text-zp-navy font-medium"
            >
              @zenithplage sur Instagram →
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 md:grid-rows-[280px_280px] gap-3 md:gap-4">
          {tiles.map((tile, i) => (
            <div
              key={i}
              data-testid={`gallery-tile-${i}`}
              className={`zoom-wrap relative ${tile.cls}`}
            >
              <img
                src={tile.src}
                alt={tile.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
